<template>
  <div id="component-container" ref="chartContainer">
    <b-spinner v-if="!show" class="spinner-center"/>
    <div class="content-pagination" v-if="show">
      <a v-if="this.$i18n.locale === 'pl'" target="_blank" href="http://nkjp.pl/poliqarp/help/plse2.html">
        <b-button size="sm" class="scale-button">⬈ Przejdź do zestawu znaczników morfosyntaktycznych</b-button>
      </a>
      <a v-if="this.$i18n.locale === 'en'" target="_blank" href="http://nkjp.pl/poliqarp/help/ense2.html">
        <b-button size="sm" class="scale-button">⬈ Go to Tagset</b-button>
      </a>
      <b-button v-if="this.scale === 'linear'" size="sm" @click.prevent="changeScale('logarithmic')" class="scale-button">{{$t('charts.scale.log')}}</b-button>
      <b-button v-if="this.scale === 'logarithmic'" size="sm" @click.prevent="changeScale('linear')" class="scale-button">{{$t('charts.scale.lin')}}</b-button>
    </div>
    <bar-chart :height="chartHeight" style="padding: 0 30px 30px 30px" id="data-chart" :chart-data="chart" :options="options" v-if="show"></bar-chart>
  </div>
</template>

<script>
  import BarChart from '../components/BarChart'
  import axios from 'axios'

  export default {
    name: 'Base',
    props: {
      taskId: {
        type: String
      }
    },
    components: {BarChart, axios},
    data () {
      return {
        resultData: null,
        chartHeight: 470,
        show: false,
        scale: 'logarithmic'
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/base')
              .then((response) => {
                if (response.data.error === 'corpus not processed') {
                  console.log(response.data.error)
                  this.$router.push({path: '/'})
                } else {
                  this.chart.datasets[0].label = '"' + response.data.a.name + '"'
                  this.chart.datasets[1].label = '"' + response.data.b.name + '"'
                }
              }).catch(function (error) {
                // handle error
                alert(error)
              })
              .finally(function () {
                // always executed
              })
      axios.get(process.env.ROOT_API + 'getData/' + this.taskId + '/pos')
              .then((response) => {
                if (response.data.error === 'corpus not processed') {
                  this.$router.push({path: '/'})
                } else {
                  this.resultData = response.data
                  console.log('result', this.resultData)
                  this.chartHeight = this.$refs.chartContainer.clientHeight - 60
                  this.renderChart()
                }
              }).catch(function (error) {
                // handle error
                alert(error)
              })
              .finally(function () {
                // always executed
              })
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    computed: {
      chart () {
        return {
          labels: [],
          datasets: [
            {
              label: 'A',
              backgroundColor: '#d79600',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              data: []
            },
            {
              label: 'B',
              backgroundColor: '#234ab1',
              pointBackgroundColor: 'white',
              borderWidth: 1,
              data: []
            }],
          legend: { // hides the legend
            display: false
          },
          scales: { // hides the y axis
            // yAxes: [{
            //   type: 'logarithmic'
            // }]
          }}
      },
      options () {
        return {
          title: {
            display: true,
            text: this.$t('charts.pos.title')
          },
          scales: {
            yAxes: [{
              type: this.scale,
              scaleLabel: {
                display: true,
                labelString: this.$t('charts.pos.title_y')
              },
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
              // type: 'logarithmic'
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString:
                        this.$t('charts.pos.title_x')
              },
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: true
          },
          tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
              label: function (tooltipItems, data) {
                return tooltipItems.yLabel
              }
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          height: 200
        }
      }
    },
    watch: {
      options: function () {
        this.redrawChart()
      }
    },
    methods: {
      renderChart () {
        let dataSet = 0
        for (var corpora in this.resultData) {
          for (var prop in this.resultData[corpora]) {
            this.chart.datasets[dataSet].data.push(this.resultData[corpora][prop])
          }
          dataSet++
        }
        for (var label in this.resultData[Object.keys(this.resultData)[0]]) {
          if (label !== 'name') {
            this.chart.labels.push(label)
          }
        }
        this.show = true
      },
      resizeChart: function () {
        if (window.innerWidth > 768) {
          this.chartHeight = Math.ceil(this.$refs.chartContainer.clientHeight - 60)
        } else {
          this.chartHeight = Math.ceil(470)
        }
      },
      redrawChart: function () {
        this.show = false
        this.resizeChart()
        setTimeout(() => {
          this.show = true
        }, 0)
      },
      handleResize (event) {
        this.redrawChart()
      },
      changeScale (scale) {
        this.scale = scale
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content-pagination {
    /*position: relative;/*/
    height: 30px;
    padding: 10px;
    /*display:inline-block;*/
  }
  .scale-button {
    float: right;
    margin-right: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Pos.vue